<script>
  import { onMount } from "svelte";
  import * as d3 from "d3";
  import * as topojson from "topojson-client";

  export let courtAbb;
  /** @type {string} */
  export let mapUrl;
</script>

<style>
  img {
    width: 30px;
    height: 30px;
  }
  @media screen and (max-width: 500px) { 
    img {
      width: 23px;
      height: 23px;
    }
  }
</style>

<img src={mapUrl} alt="{courtAbb} district" />
